<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!--for overlay :loading="get_ay_std_ft_loader" -->
        <!--api- 1  -->
        <v-card v-if="ay_std_div_list != null" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Admitted Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Academic Year"
                            outlined
                            @change="getStd()"
                            persistent-hint
                            hint="Select Academic Year "
                        />
                    </v-col>
                    <v-col sm="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_std_data"
                            return-object
                            :items="std_div_list"
                            item-text="std"
                            label="Standard"
                            outlined
                            @change="getDiv"
                            persistent-hint
                            hint="Select Standard "
                        />
                    </v-col>
                    <v-col sm="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="div"
                            return-object
                            :items="div_list"
                            item-text="div_name"
                            label="Division"
                            outlined
                            persistent-hint
                            hint="Select Division"
                        />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="status"
                            :items="status_list"
                            item-text="name"
                            return-object
                            label="Status"
                            outlined
                            @change="check_values"
                            persistent-hint
                            hint="Select Status"
                        />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="quota"
                            :items="quota_list"
                            item-text="name"
                            item-value="id"
                            label="Quota"
                            outlined
                            :return-object="false"
                            persistent-hint
                            hint="Select Quota"
                        />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                        <v-btn class="mt-6 button" color="primary" @click="getAdmittedReport" :loading="fetch_btn_load"
                            >Fetch</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box">
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Student Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.registration_number"
                            label="Registration Number"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.title" label="Title"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.firstname" label="First Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.middlename" label="Middle Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.lastname" label="Last Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.fullname" label="Full Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.date_of_birth" label="DoB"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.date_of_birth_in_words"
                            label="Date Of Birth In Words"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.bloodgroup" label="Blood Group"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.category" label="Category"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.religion" label="Religion"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.cast" label="Caste"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.subcaste" label="Sub Caste"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.nationality" label="Nationality"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.aadhar_no" label="Aadhar No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.domacile" label="Domicile"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.prizes" label="Prizes"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birth_place" label="Birth Place"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birth_address" label="Birth Address"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birthtaluka" label="Birth Taluka"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birthcity" label="Birth City"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birthdistrict" label="Birth District"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birthstate" label="Birth State"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birthcountry" label="Birth Country"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.gender" label="Gender"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.mothertoungue" label="Mother Tongue"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.isphysicallyhandicapped"
                            label="Is physically Handicapped"
                        ></v-switch>
                        <!-- <v-switch color="#0F2027" v-model="field.highest_qualification" label="Highest Qualification"></v-switch> -->
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.physicallyhandicapped_details"
                            label="Physically Handicapped Details"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.handicappedpercent"
                            label="Handicapped Percentage"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.personal_email" label="Personal Email"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.institute_email" label="Institute Email"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.health_checkup"
                            label="Health Checkup Status"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.family_type" label="Family Type"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.citizenship" label="Citizenship"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.name_adhar" label="Name as per aadhar card"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.height" label="Height"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.weight" label="Weight"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.languages_known"
                            label="Languages spoken at home"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.birth_mark" label="Birth Mark"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.medical_condition"
                            label="Medical Condition"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.allergy" label="Allergy"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.hemoglobin" label="Hemoglobin"></v-switch>
                    </v-col>
                    
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.photo" label="Student Photo Status"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.sign" label="Student Sign"></v-switch>
                    </v-col>
                      <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.student_contact_number" label="Student Contact Number"></v-switch>
                    </v-col>
                      <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.student_email" label="Student Email"></v-switch>
                    </v-col>
                      <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.student_name_as_per_doc" label="Student Name As Per Document"></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Academic Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.rollno" label="Roll No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.grno" label="GRNo"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.srn_no" label="SRN No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.quota" label="Quota"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.saralid" label="Saral-id"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.pen_no" label="PEN"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.apaar_id" label="Apaar ID"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.division" label="Division"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.standard" label="Standard"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.currentstandard" label="Current Standard"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.house" label="House"></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Admission Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.admission_form_no"
                            label="Admission Form No"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.admissionyear" label="Admission Year"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.admission_date" label="Admission Date"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.admissionstatus" label="Admission Status"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.firstadmittedclass"
                            label="First Admitted Class"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.sincewhen" label="Since When"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.previous_school_name"
                            label="Previous School Name"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.previousschoolpassingstandard"
                            label="Previous School Passing Standard"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.previousschoollastyear"
                            label="Previous School Last Year"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.previousschoolschoolboard"
                            label="Previous School SchoolBoard"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.previousschoolpercentage"
                            label="Previous School Percentage"
                        ></v-switch>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Parent Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.parent_name" label="Parent Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.parent_contact_no"
                            label="Parent Contact No"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.parentemail" label="Parent Email"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.parentoccupation" label="Parent Occupation"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.father_full_name" label="Father Full Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.mother_full_name" label="Mother Full Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.mother_first_name"
                            label="Mother First Name"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.father_name_as_per_doc"
                            label="Father Name as per Document"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.mother_name_as_per_doc"
                            label="Mother Name as per Document"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.family_income" label="Family Income"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.mobile_no" label="Mobile No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.alternate_mobile_no"
                            label="Alternate Mobile No"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.telephone_no" label="Telephone No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.primary_contact_number"
                            label="Primary No.(communication purpose)"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.father_contact_number"
                            label="Father's Contact Number"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.mother_contact_number"
                            label="Mother's Contact Number"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.father_email" label="Father's Email"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.mother_email" label="Mother's Email"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.emergency_contact_number"
                            label="Emergency Contact Number"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.emergency_contact_name"
                            label="Emergency Contact Name"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.emergency_contact_address"
                            label="Emergency Contact Address"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.father_occupation"
                            label="Father's Occupation"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.mother_occupation"
                            label="Mother's Occupation"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Address Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localaddress" label="Local Address"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localcity" label="Local City"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localtaluka" label="Local Taluka"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localdistrict" label="Local District"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localstate" label="Local State"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localcountry" label="Local Country"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.localpin" label="Local Pin"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.permanentaddress" label="Permanent Address"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.permanentpin" label="Permanent Pin"></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Other Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.driver_name" label="Driver Name"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.driver_adhar_no" label="Driver Aadhar No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.driver_mobile_no" label="Driver Mobile No"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.transportaion_mode"
                            label="Transportaion Mode"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.driver_address" label="Driver Address"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.transportation_mode"
                            label="Transportation Mode"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.home_distance_in_km_from_school"
                            label="Home Distance In Km From School"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.father_details" label="Father Details"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.mother_details" label="Mother Details"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.sibling_details" label="Siblings Details"></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.sibling_details_v2"
                            label="Sibling Details V2"
                        ></v-switch>
                    </v-col>
                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.guardian_details" label="Guardian Details"></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Unicode Fields</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_student_name"
                            label="Unicode Student Name"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.father_name_local"
                            label="Father Name (Local)"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.mother_name_local"
                            label="Mother Name (Local)"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_nationality"
                            label="Unicode Nationality"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_mother_tongue"
                            label="Unicode Mother Tongue"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_religion" label="Unicode Religion"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_caste" label="Unicode Caste"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_subcaste" label="Unicode Subcaste"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_category" label="Unicode Category"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_gender" label="Unicode Gender"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_medium" label="Unicode Medium"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_birth_place"
                            label="Unicode Birth Place"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_birth_taluka"
                            label="Unicode Birth Taluka"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_birth_district"
                            label="Unicode Birth District"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_birth_state"
                            label="Unicode Birth State"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_birth_country"
                            label="Unicode Birth Country"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch color="#0F2027" v-model="field.unicode_dob" label="Unicode DOB"></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_first_admitted_class"
                            label="Unicode First Admitted Class"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_last_school"
                            label="Unicode Last School"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_since_when"
                            label="Unicode Since When"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_permanent_address"
                            label="Unicode Permanent Address"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_temp_address"
                            label="Unicode Temporary Address"
                        ></v-switch>
                    </v-col>

                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.unicode_guardian_name"
                            label="Unicode Guardian Name"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">Examination Fields</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.subject_registration_details"
                            label="Assigned Subjects"
                        ></v-switch>
                    </v-col>
                </v-row>

                <v-row v-if="document_list != ''" dense>
                    <v-col cols="12" sm="12" md="12">
                        <v-switch color="#0F2027" v-model="field.doc_type" label="Document Uploading Status"></v-switch>
                        <span v-if="field.doc_type">
                            <span v-for="doc in document_list" :key="doc.dt_id">
                                <v-checkbox
                                    multiple
                                    class="mr-5"
                                    dense
                                    v-model="document_type"
                                    :label="doc.dt_type"
                                    :value="doc.dt_id"
                                ></v-checkbox>
                            </span>
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-switch
                            color="#0F2027"
                            v-model="field.paid_unpaid"
                            label="Paid-Unpaid Status"
                        ></v-switch>
                    </v-col>
                </v-row>
                <!-- fetch Button in toggle box -->
                <v-row justify="center">
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                        <v-btn class="mt-6 button" color="primary" @click="getAdmittedReport" :loading="fetch_btn_load"
                            >Fetch</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br />

        <!-- api-1 ends -->
        <!-- {{field_list}} -->
        <v-card class="box" v-if="field_list.length != 0" style="overflow-y: scroll">
            <v-row dense>
                <v-col cols="6" sm="1" md="1">
                    <v-btn
                        class="ma-2"
                        rounded
                        color="success"
                        outlined
                        @click="fnExcelReport('my-table-id', 'AdmittedStudentReport')"
                        ><v-icon color="success">mdi-export</v-icon>Export</v-btn
                    >
                </v-col>

                <v-col cols="6" sm="1" md="1">
                <v-btn
                    class="ma-2"
                    rounded
                    color="primary"
                    outlined
                    @click="printReport('my-table-id')"
                >
                    <v-icon color="primary">mdi-printer</v-icon>
                    Print
                </v-btn>
            </v-col>

                <v-col cols="6" sm="2" md="2" v-if="field.photo">
                    <v-btn class="ma-2 mr-4" tile outlined color="warning" @click="showPhotoPreview()">
                        Hide/Show Photo Preview
                    </v-btn>
                </v-col>

                <v-col cols="6" sm="2" md="2" v-if="field.photo">
                    <v-btn
                        class="ma-2 mr-4"
                        tile
                        outlined
                        color="blue darken-1"
                        @click="downloadAllImages"
                        :disabled="isDownloading"
                    >
                        Download all photos
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="2" md="2" v-if="field.sign">
                    <v-btn
                        class="ma-2 mr-4"
                        tile
                        outlined
                        color="blue darken-1"
                        @click="downloadAllSign"
                        :disabled="isDownloading"
                    >
                        Download all Signs
                    </v-btn>
                </v-col>

                <!-- <v-col cols="6" sm="4" md="4" class="py-4" v-if="isDownloading">
                    <b style="color: red;">Photos are downloading, please wait ...</b>
                </v-col> -->
                <!-- <v-col cols="12" sm="7" md="7" align="right" v-if="isDownloading">
                    <v-btn class="ma-2 mr-4" tile outlined color="black darken-1" @click="stopDownloads"
                        :disabled="stopDownloading">
                        Stop download
                    </v-btn>
                </v-col> -->
            </v-row>

            <!-- <v-card-text> -->
            <div id="my-table-id" v-if="field_list.length != 0">
                <table dense class="elevation-1">
                    <thead>
                        <tr>
                            <!-- SR NO COLUMN -->
                            <th>Sr No.</th>
                            <th v-for="(hl, index) in header_list" :key="index">
                                <!-- <span v-if="hl.text=='Registration Number'"></span>
                                  <span v-else>{{ hl.text }}</span> -->
                                {{ hl.text }}
                            </th>
                            <th v-if="lang_data_view">Languages Spoken At Home</th>
                            <th v-if="td_view">Photo Preview</th>
                            <th v-if="td_view_sign">Sign Preview</th>
                            <th v-if="hc_view">Health Checkup Report</th>
                            <th v-if="sub_reg_data_view">Assigned Subjects</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- {{field_list}}mayuri -->
                        <tr v-for="(fl, index) in field_list" :key="index">
                            <!-- SR NO VALUE -->
                            <td style="text-align: center; font-weight: 600">{{ index + 1 }}</td>
                            <td style="text-align: center" v-for="(hl, index1) in header_list" :key="index1">
                                <span
                                    class="regno"
                                    v-if="hl.text == 'Registration Number'"
                                    @click="showDetails(fl[hl.value])"
                                >
                                    <u>{{ fl[hl.value] }}</u></span
                                >
                                <!-- <span class="regno" v-else-if="hl.text == 'Admission Form No'" @click="showAdmission(fl[hl.value], fl.ad_yr_ay)"> <u>{{ fl[hl.value] }}</u></span> -->
                                <span
                                    class="regno"
                                    v-else-if="hl.text == 'Admission Form No'"
                                    @click="showAdmission(fl.admission_form_id, fl.ad_yr_ay)"
                                >
                                    <u>{{ fl[hl.value] }}</u></span
                                >
                                <span v-else>{{ fl[hl.value] }}</span>
                            </td>
                            <td v-if="lang_data_view">
                                <span v-for="(doc, ind) in fl.languages_known" :key="ind">
                                    {{ ind + 1 }} . {{ doc }}
                                </span>
                            </td>
                            <td v-if="sibling_data_view">
                                <span v-for="(doc, ind) in fl.sibling_details_v2" :key="ind">
                                    <!-- {{ doc }} -->
                                    <span v-if="doc.sibling1 != null">
                                        <center><b>Sibling Details 1</b></center>
                                        <b>Name : </b>
                                        {{ doc.sibling1.sibling_name }}<br />
                                        <b>Relation With Child : </b>
                                        {{ doc.sibling1.relationtype }}<br />
                                        <b>Date Of Birth : </b>
                                        {{ doc.sibling1.date_of_birth }}<br />
                                        <b>Age : </b>
                                        {{ doc.sibling1.age }}<br />
                                        <b>School Name : </b>
                                        {{ doc.sibling1.name_of_school }}<br />
                                    </span>

                                    <span v-if="doc.sibling2 != null">
                                        <center><b>Sibling Details 2</b></center>
                                        <!-- {{doc.sibling2}} -->
                                        <b>Name : </b>
                                        {{ doc.sibling2.sibling_name }}<br />
                                        <b>Relation With Child : </b>
                                        {{ doc.sibling2.relationtype }}<br />
                                        <b>Date Of Birth : </b>
                                        {{ doc.sibling2.date_of_birth }}<br />
                                        <b>Age : </b>
                                        {{ doc.sibling2.age }}<br />
                                        <b>School Name : </b>
                                        {{ doc.sibling2.name_of_school }}<br />
                                    </span>
                                </span>
                            </td>
                            <td v-if="doc_view">
                                <!-- {{fl.photo}} -->
                                <span v-for="(doc, index, ind) in fl.doc_type" :key="ind">
                                    <span class="text-color" v-if="doc == 'NO'">
                                        {{ ind + 1 }}. {{ index }} : {{ doc }} <br />
                                    </span>

                                    <span v-else> {{ ind + 1 }}. {{ index }} : {{ doc }} <br /> </span>
                                </span>
                            </td>
                            <td v-if="td_view">
                                <img v-if="fl.photo != 'NA'" :src="fl.photo" width="50px" height="50px" />
                                <span v-else class="text-color">NA</span>
                            </td>
                            <td v-if="td_view_sign">
                                <img v-if="fl.sign != 'NA'" :src="fl.sign" width="120px" height="70px" />
                                <span v-else class="text-color">NA</span>
                            </td>
                            <td v-if="hc_view">
                                <span v-if="fl.health_checkup === 'YES'">
                                    <span v-for="(file, index) in fl.health_checkup_files" :key="index">
                                        <a
                                            :href="basepath + file.health_checkup_file_path + file.health_checkup_file_name"
                                            target="_blank"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon color="#0f2027" v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span
                                                    >Health Checkup Report {{ fl.health_checkup_files.length > 1 ?
                                                    (index + 1) : '' }}</span
                                                >
                                            </v-tooltip>
                                        </a>
                                    </span>
                                </span>
                                <span class="text-color" v-if="fl.health_checkup == 'NO'">
                                    <strong>Report Not Uploaded</strong>
                                </span>
                            </td>
                            <!-- <td v-if="sub_reg_data_view">
                                <center>
                                    <span v-if="fl.subject_registration_details[0].subject != '0'">
                                        <v-btn
                                            @click="getcourse(fl.subject_registration_details[0].reg_sub_list)"
                                            class="btn-css btn"
                                        >
                                            {{ fl.subject_registration_details[0].subject }}
                                        </v-btn>
                                    </span>
                                    <v-btn v-else color="red" x-small text> Not Registered </v-btn>
                                </center>
                            </td> -->
                            <!-- <td v-if="sub_reg_data_view">
                                <center class="export-hide">
                                    <span v-if="fl.subject_registration_details[0].subject != '0'">
                                        <v-btn
                                            @click="getcourse(fl.subject_registration_details[0].reg_sub_list)"
                                            class="btn-css btn"
                                        >
                                            {{ fl.subject_registration_details[0].subject }}
                                        </v-btn>
                                    </span>
                                    <v-btn v-else color="red" x-small text> Not Registered </v-btn>
                                </center>
                                
                                <span class="export-show" style="display: none;">
                                    {{ getSubjectNamesForExcel(fl.subject_registration_details[0]) }}
                                </span>
                            </td> -->
                            <td v-if="sub_reg_data_view">
                                <center class="export-hide">
                                    <span v-if="fl.subject_registration_details[0].subject != '0'">
                                        <v-btn
                                            @click="getcourse(fl.subject_registration_details[0].reg_sub_list)"
                                            class="btn-css btn"
                                        >
                                            <span v-if="fl.subject_registration_details[0].Group_name">
                                                {{ fl.subject_registration_details[0].Group_name }} ({{ fl.subject_registration_details[0].subject }})
                                            </span>
                                            <span v-else>
                                                {{ fl.subject_registration_details[0].subject }}
                                            </span>
                                        </v-btn>
                                    </span>
                                    <v-btn v-else color="red" x-small text> Not Registered </v-btn>
                                </center>
                                
                                <span class="export-show" style="display: none;">
                                    {{ getSubjectNamesForExcel(fl.subject_registration_details[0]) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td style="font-weight: bold; text-align: right">Total Count: {{ field_list.length }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th>Sr.No.</th>
                        <th v-for="(hl, index) in header_list" :key="index">{{ hl.text }}</th>
                        <th v-if="doc_view">Document Uploading Status</th>
                        <th v-if="td_view">Photo Preview</th>
                        <th v-if="td_view_sign">Sign Preview</th>
                        <th v-if="hc_view">Health Checkup Report</th>
                        <th v-if="sub_reg_data_view">Assigned Subjects</th>
                    </tfoot>
                </table>
            </div>
            <!-- </v-card-text> -->
        </v-card>

        <!-- dialog box for student data -->
        <v-dialog v-model="show_stud_data_dialog" width="1100px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-btn icon dark @click="show_stud_data_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        <strong> Student Data </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <div class="box">
                    <center>
                        <h2 style="text-decoration: underline"><b> Student Details </b></h2>
                    </center>
                    <br />
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2"></v-col>
                        <v-col cols="12" sm="8" md="8">
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> First Name:</b>&nbsp;{{ stud_data.stud_firstname }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Middle Name:</b>&nbsp;{{ stud_data.stud_middlename }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Last Name:</b>&nbsp;{{ stud_data.stud_lastname }} </span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Registration Number:</b>&nbsp;{{ stud_data.registration_number }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Standard:</b>&nbsp;{{ stud_data.standard }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Division:</b>&nbsp;{{ stud_data.division }} </span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Quota:</b>&nbsp;{{ stud_data.quota }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Admission Date:</b>&nbsp;{{ stud_data.admission_date }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> AadharCard No:</b>&nbsp;{{ stud_data.stud_aadhar_no }} </span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Local Address:</b>&nbsp;{{ stud_data.laddress }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Contact No:</b>&nbsp;{{ stud_data.contact_number }} </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <span> <b> Permanent Address:</b>&nbsp;{{ stud_data.paddress }} </span>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <center>
                                <img :src="basepath + stud_data.photo_path" style="width: 60%; height: 200px" />
                            </center>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="show_admission_form" v-if="person_details != null" width="1500px">
            <v-card>
                <v-card>
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-btn icon dark @click="show_admission_form = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            <strong>View Admission Form </strong>
                            <small style="opacity: 0.5"
                                >(Print not allowed here, to take print out, use view application form link in admission
                                module.)</small
                            >
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <div class="box">
                        
                        <AFUWWS v-if="tenant == 'uwws'" :person_details="person_details"></AFUWWS>
                        <AFWWS v-else-if="tenant == 'wws'" :person_details="person_details"></AFWWS>
                        <AFVVP v-else-if="tenant == 'vvp'" :person_details="person_details"></AFVVP>
                        <AFZEAL v-else-if="tenant == 'zeal'" :person_details="person_details"></AFZEAL>
                        <AFEPS v-else-if="tenant == 'eps'" :person_details="person_details"></AFEPS>
                        <AFSBPPS v-else-if="tenant == 'sbpps'" :person_details="person_details"></AFSBPPS>
                        <VDAF v-else :person_details="person_details"></VDAF>
                    </div>
                </v-card>
            </v-card>
        </v-dialog>
        <!-- dialog box code end -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="dialog" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Registered Courses</strong></v-toolbar-title>
                </v-toolbar>

                <v-col cols="12">
                    <v-card class="box">
                        <span v-if="crs_list!=''">
                            <v-data-table
                                dense
                                :headers="headers"
                                :items="crs_list"
                                :search="search"
                                class="elevation-1 mytable"
                                :items-per-page="-1"
                            >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="(item, index) in items" :key="item.courseOfferingLearner">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.crs_name }}</td>
                                            <td class="text-center">{{ item.crs_type }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-data-table>
                        </span>

                        <v-row justify="center">
                            <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import VDAF from "../../Admission/ViewDownloadApplicationForm.vue";
    import AFUWWS from "../../Admission/AdmissionFormView/AddmissionFormUwws.vue";
    import AFVVP from "../../Admission/AdmissionFormView/AddmissionFormVvp.vue";
    import AFWWS from "../../Admission/AdmissionFormView/AddmissionFormWws.vue";
    import AFZEAL from "../../Admission/AdmissionFormView/AddmissionFormZeal.vue";
    import AFEPS from "../../Admission/AdmissionFormView/AdmissionFormEPS.vue";
    import AFSBPPS from "../../Admission/AdmissionFormView/AdmissionFormSbpps.vue";
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

    export default {
        components: {
            // "view-application-form": VDAF,
            VDAF,
            AFUWWS,
            AFVVP,
            AFWWS,
            AFZEAL,
            AFEPS,
            AFSBPPS,
            Breadcrumbs,
        },
        data: () => ({
            //1
            stud_data: [],
            dialog: false,
            show_stud_data_dialog: false,
            show_admission_form: false,
            overlay: false,
            search: "",
            ay_std_data: null,
            fetch_btn_load: false,
            current_academic_year: "",
            std: "",
            status: "",
            quota: "",
            isDownloading: false,
            stopDownloading: false,
            // extraBreadcrumbItems: [

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            //fields
            field: {
                father_email: false,
                father_details: false,
                sibling_details_v2: false,
                guardian_details: false,
                mother_details: false,
                driver_address: false,
                transportaion_mode: false,
                driver_mobile_no: false,
                driver_name: false,
                driver_adhar_no: false,
                mother_email: false,
                sibling_details: false,
                birth_mark: false,
                medical_condition: false,
                allergy: false,
                division: false,
                admission_form_no: false,
                firstname: false,
                middlename: false,
                lastname: false,
                fullname: false,
                student_name_as_per_doc: false,
                parent_name: false,
                parent_contact_no: false,
                date_of_birth: false,
                standard: false,
                bloodgroup: false,
                category: false,
                religion: false,
                aadhar_no: false,
                mobile_no: false,
                alternate_mobile_no: false,
                telephone_no: false,
                emergency_contact_name: false,
                emergency_contact_address: false,
                father_occupation: false,
                mother_occupation: false,
                emergency_contact_number: false,
                mother_contact_number: false,
                father_contact_number: false,
                primary_contact_number: false,
                birth_place: false,
                birth_address: false,
                father_full_name: false,
                mother_full_name: false,
                mother_first_name: false,
                mother_name_as_per_doc: false,
                father_name_as_per_doc: false,
                physicallyhandicapped_details: false,
                isphysicallyhandicapped: false,
                date_of_birth_in_words: false,
                highest_qualification: false,
                personal_email: false,
                institute_email: false,
                home_distance_in_km_from_school: false,
                gender: false,
                birthcountry: false,
                mothertoungue: false,
                // current_academic_year: false,
                admissionyear: false,
                previous_school_name: false,
                prizes: false,
                rollno: false,
                family_income: false,
                family_type: false,
                citizenship: false,
                name_adhar: false,
                height: false,
                weight: false,
                admission_date: false,
                registration_number: false,
                admissionstatus: false,
                domacile: false,
                cast: false,
                subcaste: false,
                previousschoolpassingstandard: false,
                previousschoollastyear: false,
                previousschoolschoolboard: false,
                currentstandard: false,
                previousschoolpercentage:false,
                quota: false,
                saralid: false,
                grno: false,
                srn_no: false,
                apaar_id: false,
                pen_no: false,
                // std: false,
                // status: false,
                dataTable: null,
                localaddress: false,
                localpin: false,
                permanentaddress: false,
                permanentpin: false,
                photo: false,
                sign: false,
                house: false,
                health_checkup: false,
                doc_type: false,
                languages_known: false,

                nationality: false,
                birthtaluka: false,
                birthcity: false,
                birthdistrict: false,
                birthstate: false,
                firstadmittedclass: false,
                sincewhen: false,
                localcity: false,
                localtaluka: false,
                localdistrict: false,
                localstate: false,
                localcountry: false,
                handicappedpercent: false,
                title: false,
                parentemail: false,
                parentoccupation: false,
                subject_registration_details: false,
                paid_unpaid: false,
                unicode_student_name: false,
                father_name_local: false,
                mother_name_local: false,
                unicode_nationality: false,
                unicode_mother_tongue: false,
                unicode_religion: false,
                unicode_caste: false,
                unicode_subcaste: false,
                unicode_category: false,
                unicode_gender: false,
                unicode_medium: false,
                unicode_birth_place: false,
                unicode_birth_taluka: false,
                unicode_birth_district: false,
                unicode_birth_state: false,
                unicode_birth_country: false,
                unicode_dob: false,
                unicode_first_admitted_class: false,
                unicode_last_school: false,
                unicode_since_when: false,
                unicode_permanent_address: false,
                unicode_temp_address: false,
                unicode_guardian_name: false,

            },
            all_toggle: false,
            td_view: false,
            hc_view: false,
            doc_view: false,
            father_data_view: false,
            mother_data_view: false,
            sibling_data_view: false,
            guardian_data_view: false,
            lang_data_view: false,
            sub_reg_data_view: false,
            //2
            header_list: [],
            field_list: [],
            xls_header: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            status_list: [],
            snackbar: false,
            snackbar_msg: "",
            color: "",
            awspath: null,
            basepath: null,
            document_list: [],
            document_type: [],
            quota_list: [],
            crs_list: [],
            person_details: null,
            tenant: null,
            td_view_sign: false,
            headers: [
                {
                    text: "Sr. No.",
                    sortable: false,
                    value: "srno1",
                },
                {
                    text: "Subject",
                    align: "center",
                    sortable: false,
                    value: "crs_name",
                },
                {
                    text: "Subject Type",
                    align: "center",
                    sortable: false,
                    value: "crs_type",
                },
            ],
        }),
        watch: {
            all_toggle() {
                // console.log(this.all_toggle);
                var keys = Object.keys(this.field);
                // console.log("keys:"+this.field[keys[0]])
                for (let i = 0; i < keys.length; i++) this.field[keys[i]] = this.all_toggle;
            },
        },
        methods: {
            getcourse(crs_list) {
                this.crs_list = crs_list;
                this.dialog = true;
            },
            getSubjectNamesForExcel(subjectDetails) {
                if (!subjectDetails || subjectDetails.subject === '0' || !subjectDetails.reg_sub_list) {
                    return "Not Registered";
                }
                return subjectDetails.reg_sub_list.map(sub => sub.crs_name).join(', ');
            },
            // fnExcelReport(id, name) {
            //     var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            //     tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            //     tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            //     tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            //     tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            //     tab_text = tab_text + "<table border='1px'>";
            //     var exportTable = $("#" + id).clone();
            //     exportTable.find("input").each(function (index, elem) {
            //         $(elem).remove();
            //     });

            //     exportTable.find("tr td:nth-child(2)").each(function () {
            //         $(this).attr("style", 'mso-number-format:"\\@";');
            //     });
            //     tab_text = tab_text + exportTable.html();
            //     tab_text = tab_text + "</table></body></html>";
            //     var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //     //Save the file
            //     // var blob = new Blob([tab_text], {
            //     //   type: "application/vnd.ms-excel;charset=utf-8",
            //     // });
            //     // window.saveAs(blob, fileName);
            //     const blob = new Blob([tab_text], {
            //         type: "application/vnd.ms-excel;charset=utf-8"
            //     });
            //     const filename = name + ".xls";

            //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //         // For IE
            //         window.navigator.msSaveOrOpenBlob(blob, filename);
            //     } else {
            //         // For modern browsers
            //         const url = window.URL.createObjectURL(blob);
            //         const a = document.createElement("a");
            //         a.href = url;
            //         a.download = filename;
            //         a.click();
            //         window.URL.revokeObjectURL(url);
            //     }
            // },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                
                var exportTable = $("#" + id).clone();
                
                exportTable.find("input, .export-hide").remove();
                exportTable.find(".export-show").css("display", "inline");

                let maxSub = 1;
                let targetHeader = exportTable.find("thead th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; });
                
                if (targetHeader.length > 0) {
                    let hasGroupData = false; 

                    exportTable.find("tbody tr").each(function () {
                        let text = $(this).find(".export-show").text().trim();
                        if (text && text !== "Not Registered") {
                            let subjectsPart = text.includes(" - ") ? text.substring(text.indexOf(" - ") + 3) : text;
                            let count = subjectsPart.split(",").length;
                            if (count > maxSub) maxSub = count;

                            if (text.includes(" - ")) {
                                hasGroupData = true; 
                            }
                        }
                    });

                    if (hasGroupData) {
                        targetHeader.text("Group Name");
                        exportTable.find("tfoot th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; }).text("Group Name");
                    } else {
                        targetHeader.text("Assigned Subjects");
                        exportTable.find("tfoot th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; }).text("Assigned Subjects");
                    }
                    
                    for (let i = 1; i <= maxSub; i++) {
                        exportTable.find("thead tr").append("<th>Subject " + i + "</th>");
                        exportTable.find("tfoot tr").append("<th>Subject " + i + "</th>");
                    }

                    exportTable.find("tbody tr").each(function () {
                        let targetCell = $(this).find("td").filter(function() { return $(this).find(".export-show").length > 0; });
                        if (targetCell.length > 0) {
                            let text = targetCell.find(".export-show").text().trim();
                            let groupName = "";
                            let subjectsPart = "";

                            if (text === "Not Registered" || text === "") {
                                subjectsPart = "";
                            } else if (text.includes(" - ")) {
                                let splitIndex = text.indexOf(" - ");
                                groupName = text.substring(0, splitIndex).trim();
                                subjectsPart = text.substring(splitIndex + 3).trim();
                            } else {
                                subjectsPart = text.trim();
                                groupName = "-"; 
                            }

                            let subjects = subjectsPart === "" ? [] : subjectsPart.split(",");
                            
                            targetCell.html(groupName);
                            
                            for (let i = 0; i < maxSub; i++) {
                                let subName = subjects[i] ? subjects[i].trim() : "";
                                $(this).append("<td>" + subName + "</td>");
                            }
                        }
                    });
                }

                exportTable.find("tr td:nth-child(2)").each(function () {
                    $(this).attr("style", 'mso-number-format:"\\@";');
                });
                
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
                const blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" });
                
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            // printReport(id) {
            //     const printContents = document.getElementById(id).innerHTML;
            //     const printWindow = window.open("", "_blank");
            //     printWindow.document.write(`
            //         <html>
            //         <head>
            //             <title>Admitted Student Report</title>

            //             <style>
            //                 body{
            //                     font-family: Arial, sans-serif;
            //                     margin:20px;
            //                     font-size:12px;
            //                 }

            //                 table{
            //                     width:100%;
            //                     border-collapse:collapse;
            //                 }

            //                 table, th, td{
            //                     border:1px solid #000;
            //                 }

            //                 th,td{
            //                     padding:5px;
            //                     text-align:left;
            //                     word-break:break-word;
            //                 }

            //                 th{
            //                     background:#f0f0f0;
            //                 }

            //                 img{
            //                     width:50px;
            //                     height:50px;
            //                 }

            //                 @media print{
            //                     body{
            //                         margin:0;
            //                     }

            //                     table{
            //                         page-break-inside:auto;
            //                     }

            //                     tr{
            //                         page-break-inside:avoid;
            //                         page-break-after:auto;
            //                     }

            //                     thead{
            //                         display:table-header-group;
            //                     }

            //                     tfoot{
            //                         display:none;
            //                     }
            //                 }
            //             </style>
            //         </head>

            //         <body>
            //             <h2 style="text-align:center;">
            //                 Admitted Student Report
            //             </h2>

            //             ${printContents}

            //         </body>
            //         </html>
            //     `);

            //     printWindow.document.close();

            //     printWindow.focus();

            //     setTimeout(() => {
            //         printWindow.print();
            //         printWindow.close();
            //     }, 500);
            // },
            
           printReport(id) {
                var printTable = $("#" + id).clone();

                printTable.find("input, .export-hide").remove();
                printTable.find(".export-show").css("display", "inline");

                let maxSub = 1;
                let targetHeader = printTable.find("thead th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; });
                
                if (targetHeader.length > 0) {
                    let hasGroupData = false; 

                    printTable.find("tbody tr").each(function () {
                        let text = $(this).find(".export-show").text().trim();
                        if (text && text !== "Not Registered") {
                            let subjectsPart = text.includes(" - ") ? text.substring(text.indexOf(" - ") + 3) : text;
                            let count = subjectsPart.split(",").length;
                            if (count > maxSub) maxSub = count;

                            if (text.includes(" - ")) {
                                hasGroupData = true;
                            }
                        }
                    });

                    if (hasGroupData) {
                        targetHeader.text("Group Name");
                        printTable.find("tfoot th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; }).text("Group Name");
                    } 
                    else {
                        targetHeader.text("Assigned Subjects");
                        printTable.find("tfoot th").filter(function() { return $(this).text().trim() === "Assigned Subjects"; }).text("Assigned Subjects");
                    }
                    
                    for (let i = 1; i <= maxSub; i++) {
                        printTable.find("thead tr").append("<th>Subject " + i + "</th>");
                        printTable.find("tfoot tr").append("<th>Subject " + i + "</th>");
                    }

                    printTable.find("tbody tr").each(function () {
                        let targetCell = $(this).find("td").filter(function() { return $(this).find(".export-show").length > 0; });
                        if (targetCell.length > 0) {
                            let text = targetCell.find(".export-show").text().trim();
                            let groupName = "";
                            let subjectsPart = "";

                            if (text === "Not Registered" || text === "") {
                                subjectsPart = "";
                                groupName = "-";
                            } else if (text.includes(" - ")) {
                                let splitIndex = text.indexOf(" - ");
                                groupName = text.substring(0, splitIndex).trim();
                                subjectsPart = text.substring(splitIndex + 3).trim();
                            } else {
                                subjectsPart = text.trim();
                                groupName = "-"; 
                            }

                            let subjects = subjectsPart === "" ? [] : subjectsPart.split(",");
                            
                            targetCell.html(groupName);
                            
                            for (let i = 0; i < maxSub; i++) {
                                let subName = subjects[i] ? subjects[i].trim() : "";
                                $(this).append("<td>" + subName + "</td>");
                            }
                        }
                    });
                }

                const printContents = printTable.html();
                const printWindow = window.open("", "_blank");
                
                printWindow.document.write(`
                    <html>
                    <head>
                        <title>Admitted Student Report</title>
                        <style>
                        @page { size: landscape; margin: 10mm; }
                            body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
                            table { width: 100%; border-collapse: collapse; }
                            table, th, td { border: 1px solid #000; }
                            th, td { padding: 5px; text-align: left; word-break: break-word; }
                            th { background: #f0f0f0; }
                            img { width: 50px; height: 50px; }
                            @media print {
                                body { margin: 0; }
                                table { page-break-inside: auto; }
                                tr { page-break-inside: avoid; page-break-after: auto; }
                                thead { display: table-header-group; }
                                tfoot { display: table-row-group; }
                            }
                        </style>
                    </head>
                    <body>
                        <h2 style="text-align:center;">Admitted Student Report</h2>
                        <table border="1px">${printContents}</table>
                    </body>
                    </html>
                `);

                printWindow.document.close();
                printWindow.focus();

                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);
            },

            showPhotoPreview() {
                if (this.td_view) {
                    this.td_view = false;
                } else {
                    this.td_view = true;
                }
            },
            getFileExtension(url) {
                if (url) {
                    return url.split(".").pop().split(/\#|\?/)[0];
                } else {
                    console.error("URL is undefined");
                    return "";
                }
            },

            async downloadAllImages() {
                this.isDownloading = true;
                this.showSnackbar("success", " Photos are downloading, please wait... ");
                const formData = {
                    learner: this.field_list.map((item) => item.learnerId),
                };
                try {
                    axios
                        .post("/admissionReport/renderLearnerPhotoZip", formData, {
                            responseType: "blob",
                        })
                        .then((res) => {
                            const blob = new Blob([res.data], { type: "application/zip" });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = "Learner_Photos.zip";
                            link.click();
                        });
                } catch (error) {
                    this.showSnackbar("error", "Something went wrong...");
                } finally {
                }
            },
            async downloadAllSign() {
                this.isDownloading = true;
                this.showSnackbar("success", " Signatures are downloading, please wait... ");
                const formData = {
                    learner: this.field_list.map((item) => item.learnerId),
                };
                try {
                    axios
                        .post("/admissionReport/renderLearnerSignZip", formData, {
                            responseType: "blob",
                        })
                        .then((res) => {
                            const blob = new Blob([res.data], { type: "application/zip" });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = "Learner_Sign.zip";
                            link.click();
                        });
                } catch (error) {
                    this.showSnackbar("error", "Something went wrong...");
                } finally {
                }
            },

            async downloadImg(imageSrc, reg_number) {
                // console.log("image url "+imageSrc);
                if (!imageSrc) {
                    console.error("Image source is undefined or empty");
                    return;
                }

                const downloadFilename = reg_number;
                const proxyUrl = "https://api.allorigins.win/get?url=";
                const imageUrl = proxyUrl + encodeURIComponent(imageSrc);
                const extension = this.getFileExtension(imageSrc);
                const supportedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];

                if (!supportedExtensions.includes(extension.toLowerCase())) {
                    console.error("Unsupported file extension:", extension);
                    return;
                }

                const fullDownloadFilename = `${downloadFilename}.${extension}`;

                try {
                    // Fetch the image data
                    const response = await fetch(imageUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = await response.json();
                    const blobResponse = await fetch(data.contents);
                    const blob = await blobResponse.blob();

                    // Create a link element and trigger a download
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = fullDownloadFilename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error("Error downloading the image:", error);
                }
            },
            sleep(ms) {
                return new Promise((resolve) => setTimeout(resolve, ms));
            },
            // async downloadAllImages() {
            //     this.isDownloading = true;
            //     this.stopDownloading = false;
            //     this.showSnackbar("success", " Photos are downloading, please wait... ");
            //     let count = 0;
            //     for (let field of this.field_list) {
            //         if (this.stopDownloading) {
            //             this.showSnackbar("error", "Downloading has stopped");
            //             break;
            //         }
            //         if (field.photo != '' && field.photo != null) {
            //             await this.downloadImg(field.photo, field.registration_number);
            //             await this.sleep(500); // Added 0.5 second delay
            //             count++;
            //         }
            //         this.showSnackbar("info", "Completed " + count + " of " + this.field_list.length);
            //     }
            //     this.isDownloading = false;
            //     if (!this.stopDownloading) {
            //         this.showSnackbar("success", "All photos are downloaded successfully !");
            //     }
            // },
            stopDownloads() {
                this.stopDownloading = true;
            },
            async showAdmission(form_no, ay) {
                // alert(ay)
                if (form_no == "NA") {
                    this.showSnackbar("error", "Invalid form no!!!");
                    retrun;
                }
                let ay_id;
                if (this.sel_ay_data.ay_id) {
                    ay_id = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay_id = this.sel_ay_data.id;
                }
                localStorage.setItem("setay", ay_id);
                localStorage.setItem("setform_id", form_no);
                localStorage.setItem("admission-ay", ay_id);
                this.show_admission_form = false;
                const formData = {
                    ay: ay_id,
                    form_id: form_no,
                };

                try {
                    const res = await axios.post("/Admission/get_application_form", formData);
                    if (res.data.status.code == "SUCCESS") {
                        this.person_details = res.data.person_details;
                        console.log(this.person_details);
                        this.show_admission_form = true;
                    } else {
                        this.showSnackbar("error", "Can't show form!!!");
                        this.person_details = null;
                    }
                } catch (error) {
                    this.showSnackbar("error", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            showDetails(registration_number) {
                //  alert("registration_number::"+registration_number)
                const formData = {
                    ay: this.sel_ay_data.ay_id,
                    learner: registration_number,
                };
                axios
                    .post("/admissionReport/getLearnerDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.stud_data = res.data.stud_data;
                            this.show_stud_data_dialog = true;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        // this.dialog_showdetails = false
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            check_values() {
                if (this.sel_std_data == null) {
                    this.showSnackbar("#b71c1c", "Please select Academic Year then proceed further!"); // show snackbar
                }
            },
            getStd() {
                this.std_div_list = ["All"];
                this.sel_std_data = "All";
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
                this.std_div_list.unshift("All");
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            getAdmittedReport() {
                if (this.isDownloading) {
                    this.stopDownloads();
                    this.isDownloading = false;
                }
                if (this.field.photo == true) {
                    this.td_view = true;
                } else {
                    this.td_view = false;
                }
                if (this.field.sign == true) {
                    this.td_view_sign = true;
                } else {
                    this.td_view_sign = false;
                }
                if (this.field.health_checkup == true) {
                    this.hc_view = true;
                } else {
                    this.hc_view = false;
                }
                if (this.field.doc_type == true) {
                    this.doc_view = true;
                } else {
                    this.doc_view = false;
                }
                if (this.field.father_details == true) {
                    this.father_data_view = true;
                } else {
                    this.father_data_view = false;
                }
                if (this.field.sibling_details_v2 == true) {
                    this.sibling_data_view = true;
                } else {
                    this.sibling_data_view = false;
                }
                if (this.field.guardian_details == true) {
                    this.guardian_data_view = true;
                } else {
                    this.guardian_data_view = false;
                }
                if (this.field.mother_details == true) {
                    this.mother_data_view = true;
                } else {
                    this.mother_data_view = false;
                }
                if (this.field.languages_known == true) {
                    this.lang_data_view = true;
                } else {
                    this.lang_data_view = false;
                }
                if (this.field.subject_registration_details == true) {
                    this.sub_reg_data_view = true;
                } else {
                    this.sub_reg_data_view = false;
                }

                this.field_list = [];
                this.fetch_btn_load = true;

                let div;
                if (this.div != null) {
                    div = this.div.div_off_id;
                    if (this.div.div_off_id) {
                        div = this.div.div_off_id;
                    } else {
                        div = this.div;
                    }
                }
                let ay;
                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }
                let data = {
                    current_academic_year_id: ay,
                    standard_obj: this.sel_std_data,
                    division_off_id: div,
                    status: this.status,
                    field: this.field,
                    document_type: this.document_type,
                    quota: this.quota,
                };
                axios
                    .post("/admissionReport/getAdmittedReport", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.field_list = res.data.field_list;
                            this.header_list = res.data.header_list;
                            this.xls_header = res.data.xls_header;

                            // this.dataTable = $("#admitted-student-report").DataTable({
                            //   colReorder: true,
                            //   dom: "Bfrtip",
                            //   buttons: ["csvHtml5", "excelHtml5", "print"],
                            // });
                        } else {
                            //error
                        }
                        this.fetch_btn_load = false;
                        // console.log("try")
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.fetch_btn_load = false;
                    })
                    .finally(() => {
                        //close loader
                        // console.log("finally")
                    });
            },
            get_ay_std() {
                this.overlay = true;
                //api-1
                axios
                    .post("/CommonAPI/get_ay_std_div_for_report_by_access")
                    .then((res) => {
                        this.overlay = false;
                        // if (res.data.msg == "200") {
                        this.ay_std_div_list = res.data.data;
                        // this.sel_ay_data = res.data.curr_ay;
                        this.status_list = res.data.status_list;
                        this.status = this.status_list[0];
                        this.document_list = res.data.document_list;

                        const list = res.data.quota_list;
                        this.quota_list = [
                            { id: "All", name: "All" },
                            ...list.map((item) => ({
                                ...item,
                                id: String(item.id),
                            })),
                        ];

                        this.quota = this.quota_list[0].id;

                        // this.ay_std_data = res.data.fees_structure_data;
                        // // this.field.current_academic_year = res.data.fees_structure_data.current_academic_year;
                        // // this.field.std = this.ay_std_data.standard_list[0];
                        // // this.field.status = this.ay_std_data.status_list[0];
                        //  this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                        // this.std = this.ay_std_data.standard_list[0];
                        // this.ay_std_data.standard_list.unshift("All");
                        // } else {
                        //     //error
                        // }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                        //close loader
                    });
            },
            getSubjectNamesForExcel(subjectDetails) {
                if (!subjectDetails || subjectDetails.subject === '0' || !subjectDetails.reg_sub_list || subjectDetails.reg_sub_list.length === 0) {
                    return "Not Registered";
                }
                
                const subjects = subjectDetails.reg_sub_list.map(sub => sub.crs_name).join(', ');
                
                const groupName = subjectDetails.Group_name ? `${subjectDetails.Group_name} - ` : "";
                
                return groupName + subjects;
            },
        },
        created() {
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
        },
        mounted() {
            this.get_ay_std();
            this.basepath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    .text-color {
        color: red;
    }

    .mytable1 {
        /* width: 90%; */
        overflow-x: scroll !important;
    }

    table,
    th,
    td {
        border: 1px solid rgb(201, 200, 200);
        border-collapse: collapse;
    }

    tbody,
    td {
        font-weight: 400;
    }

    .regno :hover {
        cursor: pointer;
    }
    .section-heading {
        font-weight: 600;
        color: #0f2027;
        border-bottom: 1px solid #ddd;
        padding-bottom: 6px;
        margin: 16px 0;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
</style>
